module.exports = __webpack_public_path__ + "img/cashback_big.13c34ae.7165146d.png";